import React, { HTMLAttributes } from 'react';

import { ConfirmationTemplate, ConfirmationTemplateProps } from '../base';

import { CtaButton, Button } from '../../../atoms/button/genesis-button';

import styles from './gen-confirmation-template.module.scss';

export function GenConfirmationTemplate(props: ConfirmationTemplateProps) {
	return (
		<ConfirmationTemplate
			{...props}
			TitleComponent={GenTitle}
			CancelButton={Button}
			ConfirmButton={CtaButton}
			actionsClass={styles.actions}
		/>
	);
}

export function GenTitle(props: HTMLAttributes<HTMLDivElement>) {
	return <div {...props} className={styles.genTitle} />;
}
